import axios from 'axios';
import config from '../config';
import { PostOnboardDeviceLogsRequest } from '../interfaces';

export const postOnboardDeviceLogs = (deviceId: string, request: PostOnboardDeviceLogsRequest) => {
    return axios.post(`${config.API_URL}/onboard-devices/${deviceId}/logs`, request).then((response: any) => {
        return response.data;
    });
};
